import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./components/App";
import { ParentGate } from "./components/ParentGate";
import "./styles/motion.css";
import "./styles/app.css";
import "./styles/book.css";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      {/* Invited-families gate (pass-through when Supabase isn't configured). */}
      <ParentGate>
        <App />
      </ParentGate>
    </StrictMode>
  );
}
